import { Button } from '@progress/kendo-react-buttons';
import { SvgIcon } from '@progress/kendo-react-common';
import { useEffect, useState } from 'react';
import { CheckmarkCircleSolid, CircleOutline, CloseCircleOutline } from '../../../../../icons/icons';

export function SettingsAlertNotificationsElement() {
    const [state, setState] = useState<PermissionState>();
    useEffect(() => {
        navigator.permissions.query({ name: 'notifications' }).then((x) => {
            setState(x.state);
        });
    }, []);

    const askPermission = () => {
        Notification.requestPermission().then((x) => {
            if (x === 'default') {
                return;
            }
            setState(x);
        });
    };

    const sendTestNotification = () => {
        new Notification('Sample notification title', {
            body: 'Sample notification body',
            icon: import.meta.env.BASE_URL + "img/favicon.ico",
        });
    };

    return (
        <div className="px-3 d-flex align-items-center">
            {state === 'granted' && (
                <div className="d-flex gap-1 align-items-center flex-grow-1">
                    <SvgIcon icon={CheckmarkCircleSolid} themeColor="success" />
                    <div className="flex-grow-1">Permission granted</div>
                    <Button onClick={sendTestNotification}>Send test notification</Button>
                </div>
            )}
            {state === 'prompt' && (
                <div className="d-flex gap-1 align-items-center flex-grow-1">
                    <SvgIcon icon={CircleOutline} />
                    <div className="flex-grow-1">Permission pending</div>
                    <Button onClick={askPermission}>Allow</Button>
                </div>
            )}
            {state === 'denied' && (
                <div className="d-flex gap-2 align-items-center flex-grow-1">
                    <SvgIcon icon={CloseCircleOutline} themeColor="error" />
                    <div className="flex-grow-1">
                        <div>Permission denied</div>
                        <div className="secondary-text" style={{ fontSize: '0.8em' }}>
                            Go to navigation bar in your browser and allow notifications.
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
